import styled from 'styled-components';
import { PageTitle } from '../../../../components';

export const PageTitleStyled = styled(PageTitle)`
  margin-bottom: 2rem;
`;
